import { Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { Profile } from './master-visualizar-perfil.model';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
const BASE_PATH = environment.basePath;
const headers = new HttpHeaders({ "Content-Type": "application/json" });

@Injectable({
  providedIn: 'root',
})
export class MasterVisualizarPerfilService {
  constructor(private httpClient:  HttpClient) {}

  getProfile(payload: any) {
    return this.httpClient.post<Profile>(`${BASE_PATH}/bff/permissionGroups/list-profile`, payload);
  }

  postDuplicateProfile(profile: Profile): Observable<any> {
    return this.httpClient.post<any>(`${BASE_PATH}/bff/permissionGroups/duplicate/` + profile.id, { headers: headers });
  }

  deleteProfile(profileId: any): Observable<any> {
    return this.httpClient.delete<any>(`${BASE_PATH}/bff/permissionGroups/delete/` + profileId);
  }
}
